import { OktaAuth } from "@okta/okta-auth-js";

export function OktaClient(OAuthConfig) {
  doValidation();
  this.OAuthConfig = OAuthConfig;
  const myMemoryStore = {};
  const storageProvider = {
    getItem: function (key) {
      // custom get
      console.info(`Getting ${key} from memory store. No Op`);
      return myMemoryStore[key];
    },
    setItem: function (key, val) {
      // custom set
      console.info(`NOT Setting ${key} in memory store.`);
      // myMemoryStore[key] = val;
    },
    // optional
    removeItem: function (key) {
      console.info(`removing item ${key} from memory store. No OP.`);
      delete myMemoryStore[key];
    },
  };
  this.OAuthConfig.storageManager = {
    token: {
      storageProvider: storageProvider,
    },
  };
  this.authClient = new OktaAuth(this.OAuthConfig);
  // this.authClient.start();
  this.login = async () => {
    if (this.authClient.isLoginRedirect()) {
      // Parse token from redirect url
      return await this.parseTokenFromURL();
    } else {
      // Attempt to retrieve ID Token from Token Manager
      return await this.getTokenWithRedirect();
    }
  };
  this.logout = async () => {
    await this.authClient.signOut();
    // this.authClient.stop();
  };
  this.parseTokenFromURL = async () => {
    const data = await this.authClient.token.parseFromUrl();
    const { idToken, accessToken, refreshToken } = data.tokens;
    // Store parsed token in Token Manager
    this.authClient.tokenManager.add("idToken", idToken);
    this.authClient.tokenManager.add("accessToken", accessToken);
    this.authClient.tokenManager.add("refreshToken", refreshToken);
    return { idToken, accessToken, refreshToken };
    // this.authClient.token.parseFromUrl().then((data) => {

    // });
  };
  this.getTokenWithRedirect = async () => {
    const idToken = await this.authClient.tokenManager.get("idToken");
    const accessToken = await this.authClient.tokenManager.get("accessToken");
    const refreshToken = await this.authClient.tokenManager.get("refreshToken");
    if (idToken && accessToken && refreshToken) {
      // also check for refresh token?
      return { idToken, accessToken, refreshToken };
    } else {
      // You're not logged in, you need a sessionToken
      await this.authClient.token.getWithRedirect({
        scopes: ["openid", "email", "profile", "offline_access"],
      }); // need to pass in idp parameter?
    }
    // this.authClient.tokenManager.get("idToken").then((idToken) => {
    //   if (idToken) {
    //     console.log(`Hi ${idToken.claims.email}!`); // TODO : return a token here??
    //   } else {
    //   }
    // });
  };
  this.getAccessToken = () => {
    this.authClient.tokenManager.get("accessToken").then((accesToken) => {
      return accesToken;
    });
  };
  this.isLoggedIn = async () => {
    let isLoggedIn = false;
    // await this.authClient.authStateManager.updateAuthState();
    isLoggedIn = await this.authClient.isAuthenticated();
    return isLoggedIn;
  };
  this.getClient = () => this.authClient;
}

function doValidation() {
  if (!OktaAuth.features.isPKCESupported()) {
    throw new Error(
      "Your browser needs to be upgraded to support the OAuth authentication!"
    );
  }
}
